export default __webpack_public_path__ + "static/thumb-landscape-b03a725ce4bc386c26ff53904eac7d16.jpg";